import { observer } from 'mobx-react';
import * as React from 'react';
import ImportParticipantsStore from './Store';
import Loader from '../../Loader';
import UploadFile from './UploadFile';
import PreviewTable from './Tables/PreviewTable';
import ReportTable from './Tables/ReportTable';
import ImportParticipantsStatus from './ImportParticipantsStatus';

interface Props {
  store: ImportParticipantsStore;
}

const ImportParticipantsState: React.FC<Props> = ({ store }) => {
  switch (store.state.kind) {
    case 'waiting':
    case 'loading':
      return <Loader />;
    case 'uploading-ready':
    case 'file-selected':
    case 'file-select-failed':
      return <UploadFile store={store} />;
    case 'file-select-succeeded':
    case 'submit':
      return <PreviewTable store={store} rows={store.state.rows} filename={store.state.filename} />;
    case 'submit-succeeded':
      return <ImportParticipantsStatus store={store} state={store.state} />;
    case 'view-report':
      return (
        <ReportTable
          store={store}
          viewReport={store.state.view}
          filename={store.state.filename}
          totalCount={store.state.initialCount}
          importedParticipantsResource={store.state.importedParticipantsResource}
        />
      );
    case 'error':
      return <></>;
  }
};

export default observer(ImportParticipantsState);
